// Page-entrance registry. Resolves the entrance animation for the current page from
// body[data-reveal-template] + the entry type (direct | swup | history). The reveal
// controller calls revealPage() at reveal time; see README "Page reveal & loader".
//
// To add a page: create ./templates/<name>.js exporting { direct, swup, history } and
// register it in the `templates` map below.
import { createRevealContext } from './context'

// template reveal modules
import home from './templates/home'

import about from './templates/about'
import project from './templates/project'

// import project from './templates/project'
// import article from './templates/article'

// registry
const templates = {
	home,
	about,
	project,
}

/**
 * Run page reveal for current template + entry type
 *
 * @param {'direct'|'swup'|'history'} entry
 * @returns {gsap.core.Timeline|null|void}
 */
export function revealPage(entry) {
	const ctx = createRevealContext()
	const templateName = ctx.template
	if (!templateName) return

	const template = templates[templateName]
	if (!template) return
	// resolve reveal: entry-specific or fallback
	const reveal = template[entry] || template.default

	if (!reveal) return

	return reveal(ctx)
}
